module.exports = __webpack_public_path__ + "img/part4_bg.6cf35ba5.jpg";